import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  clearEvents: null,
  createEventFailure: null,
  createEventRequest: ["params", "resolve", "reject"],
  createEventSuccess: ["event"],
  createManualEventFailure: null,
  createManualEventRequest: ["params", "resolve", "reject"],
  createManualEventSuccess: ["event"],
  updateManualEventFailure: null,
  updateManualEventRequest: [
    "eventId",
    "params",
    "resolve",
    "reject",
  ],
  updateManualEventSuccess: ["eventData"],
  getEventMembersFailure: null,
  getEventMembersRequest: ["eventId"],
  getEventMembersSuccess: ["members"],
  createEventMemberFailure: null,
  createEventMemberRequest: [
    "eventId",
    "params",
    "resolve",
    "reject",
  ],
  createEventMemberSuccess: ["member"],
  markAttendanceFailure: ["eventId", "registrationId", "attended"],
  markAttendanceRequest: [
    "eventId",
    "registrationId",
    "attended",
    "resolve",
    "reject",
  ],
  markAttendanceSuccess: ["registration"],
  addRegistrationFailure: null,
  addRegistrationRequest: ["eventId", "userId", "resolve", "reject"],
  addRegistrationSuccess: ["registration"],
  deleteEventMemberFailure: null,
  deleteEventMemberRequest: ["eventId", "id"],
  deleteEventMemberSuccess: ["id"],
  downloadEventsFailure: null,
  downloadEventsRequest: ["params"],
  downloadEventsSuccess: ["url"],
  getEventsFailure: null,
  getEventsRequest: ["params", "resolve", "reject"],
  getEventsSuccess: ["eventsData", "params"],
  getEventFailure: null,
  getEventRequest: ["params"],
  getEventSuccess: ["eventData"],
  rescheduleEventFailure: null,
  rescheduleEventRequest: ["params"],
  rescheduleEventSuccess: ["eventData"],
  confirmEventFailure: null,
  confirmEventRequest: ["params"],
  confirmEventSuccess: ["eventData"],
  cancelEventFailure: null,
  cancelEventRequest: ["params"],
  cancelEventSuccess: ["eventData"],
  updateLocationFailure: null,
  updateLocationRequest: ["params"],
  updateLocationSuccess: ["eventData"],
});

export const EventsTypes = Types;
export const EventsCreators = Creators;
